import React from "react";
import CategoryServices from "../services/CategoryServices";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@material-ui/core";
import { clearParentSchoolSession } from "../utils/schoolImpersonation";

var UserStateContext = React.createContext();
var UserDispatchContext = React.createContext();

function userReducer(state, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return { ...state, isAuthenticated: true };
    case "SIGN_OUT_SUCCESS":
      return { ...state, isAuthenticated: false };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function UserProvider({ children }) {
  var [state, dispatch] = React.useReducer(userReducer, {
    isAuthenticated: !!localStorage.getItem("id_token"),
  });

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
}

function useUserState() {
  var context = React.useContext(UserStateContext);
  if (context === undefined) {
    throw new Error("useUserState must be used within a UserProvider");
  }
  return context;
}

function useUserDispatch() {
  var context = React.useContext(UserDispatchContext);
  if (context === undefined) {
    throw new Error("useUserDispatch must be used within a UserProvider");
  }
  return context;
}

export { UserProvider, useUserState, useUserDispatch, loginUser, signOut };

function loginUser(dispatch, login, password, history, setIsLoading, setError, roleType,
  //  setShowPasswordDialog,
   handlePasswordChangeConfirm) {
  setError(false);
  setIsLoading(true);
  if (!!login && !!password) {
    const  userDetails =   {"email":login,"password":password, "role":roleType}
    CategoryServices.creteUserLogin(userDetails).then((res) => {
      clearParentSchoolSession();
      localStorage.setItem('userDetail', JSON.stringify(res));
      localStorage.setItem('id_token', res.token);
      if (res.refreshToken) {
        localStorage.setItem('refresh_token', res.refreshToken);
      }
      if (res.screens) {
        localStorage.setItem('rbac_screens', JSON.stringify(res.screens));
      }
      if (res.permissions) {
        localStorage.setItem('rbac_permissions', JSON.stringify(res.permissions));
      }
      setError(null)
      setIsLoading(false)
     
      
 if(res.role == "SUPERADMIN"){
  dispatch({ type: 'LOGIN_SUCCESS' })
  history.push('/app/schooldetails') ;
 }else if(res.role == "PARENT" ){
  if(res.passwordReset==false){
    
    handlePasswordChangeConfirm();
    return; 
    }else{
      
      dispatch({ type: 'LOGIN_SUCCESS' })
      history.push('/app/assignment') ;
    }

  // history.push('/app/assignment') ;
 }else if (res.role === "TEACHER") {
  dispatch({ type: 'LOGIN_SUCCESS' });
  history.push('/app/studentactivity'); // 👈 this is the change
}else if(res.role === "SCHOOLE"){
  dispatch({ type: 'LOGIN_SUCCESS' });
  history.push('/app/studentdetails'); 
}

else {
  dispatch({ type: 'LOGIN_SUCCESS' });
  history.push('/app/studentdetails');
}
//  else{
//   history.push('/app/studentdetails') ;
//   dispatch({ type: 'LOGIN_SUCCESS' })
//  }
    
     // window.location.reload(false);


    }).catch((err) => {
      const errorMessage = err.response?.data?.message
      alert(errorMessage)
      setIsLoading(false);
      history.push('/montessori/login')
    });
  } 
}
function signOut(dispatch, history) {
  const refreshToken = localStorage.getItem("refresh_token");
  if (refreshToken) {
    CategoryServices.logoutUser({ refreshToken }).catch(() => {});
  }
  localStorage.removeItem("id_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("userDetail");
  localStorage.removeItem("rbac_screens");
  localStorage.removeItem("rbac_permissions");
  clearParentSchoolSession();
  dispatch({ type: "SIGN_OUT_SUCCESS" });
  history.push("/montessori/login");
}
